import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LabelI18nService } from '../_services/label-i18n.service';

@Pipe({
  name: 'localizedNumber',
  pure: false
})
export class LocalizedNumberPipe implements PipeTransform {
  constructor(private labelI18n: LabelI18nService) {}

  transform(value: number | string | null | undefined, digitsInfo?: string): string | null {
    if (value === null || value === undefined || value === '' || !isFinite(Number(value))) return null;
    return formatNumber(Number(value), this.labelI18n.locale, digitsInfo);
  }
}
